module.exports = __webpack_public_path__ + "static/media/NL.ea0825da.png";